import type { Detection } from '../types';

/** ?debug=1 のときだけ表示する計測 HUD とボックス描画。無効時は何もしない。 */
export class Hud {
  private readonly fields: HTMLElement;
  private readonly logEl: HTMLElement;
  private readonly canvas: HTMLCanvasElement;
  private readonly video: HTMLVideoElement;
  /** デバッグ用「認識テスト」: 検出なしで認識時の処理を発火させる。 */
  readonly recognizeButton: HTMLButtonElement;

  constructor(root: Document, readonly enabled: boolean) {
    this.fields = root.getElementById('hud-fields')!;
    this.logEl = root.getElementById('hud-log')!;
    this.canvas = root.getElementById('overlay') as HTMLCanvasElement;
    this.video = root.getElementById('video') as HTMLVideoElement;
    root.getElementById('hud')!.hidden = !enabled;
    this.recognizeButton = root.getElementById('debug-recognize') as HTMLButtonElement;
    this.recognizeButton.hidden = !enabled;
  }

  update(fields: Record<string, string>): void {
    if (!this.enabled) return;
    this.fields.replaceChildren(
      ...Object.entries(fields).map(([k, v]) => {
        const s = document.createElement('span');
        s.textContent = `${k} ${v}`;
        return s;
      }),
    );
  }

  setLog(lines: string[]): void {
    if (!this.enabled) return;
    this.logEl.textContent = lines.slice(-8).join('\n');
  }

  /** object-fit: cover の video に合わせて正規化ボックスを描く。 */
  drawBoxes(dets: Detection[], hot: (d: Detection) => boolean): void {
    if (!this.enabled) return;
    const c = this.canvas;
    const dpr = window.devicePixelRatio || 1;
    const cw = c.clientWidth, ch = c.clientHeight;
    if (c.width !== Math.round(cw * dpr) || c.height !== Math.round(ch * dpr)) {
      c.width = Math.round(cw * dpr);
      c.height = Math.round(ch * dpr);
    }
    const ctx = c.getContext('2d')!;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, cw, ch);
    const sw = this.video.videoWidth || 1, sh = this.video.videoHeight || 1;
    const s = Math.max(cw / sw, ch / sh);
    const dw = sw * s, dh = sh * s, ox = (cw - dw) / 2, oy = (ch - dh) / 2;
    ctx.lineWidth = 3;
    ctx.font = 'bold 14px system-ui, sans-serif';
    for (const b of dets) {
      const x = ox + b.x1 * dw, y = oy + b.y1 * dh, w = (b.x2 - b.x1) * dw, h = (b.y2 - b.y1) * dh;
      const color = hot(b) ? '#3ddc84' : '#ffb300';
      ctx.strokeStyle = color;
      ctx.strokeRect(x, y, w, h);
      const text = `${b.cls} ${b.score.toFixed(2)}`;
      ctx.fillStyle = '#000a';
      ctx.fillRect(x, Math.max(0, y - 20), ctx.measureText(text).width + 8, 20);
      ctx.fillStyle = color;
      ctx.fillText(text, x + 4, Math.max(14, y - 5));
    }
  }
}
